import { z } from 'zod'

const uuid = z.string().uuid()
const text = z.string().min(1)
const timestamp = z.string().datetime()
const quantity = z.string().regex(/^\d+(?:\.\d+)?$/, 'Use uma quantidade decimal com ponto.')

export const productionCatalogSchema = z.object({
  workstations: z.array(z.object({
    id: uuid, code: text, name: text, active: z.boolean(),
  }).strict()),
  access: z.array(z.object({
    workstation_id: uuid, user_id: z.number().int().positive(),
  }).strict()),
  jobs: z.array(z.object({
    id: uuid,
    workstation_id: uuid,
    context: z.object({
      erp_company: text,
      production_order: text,
      order_line: z.number().int(),
      component_line: z.number().int(),
      produced_item: text,
      material_item: text,
      operation: text,
      workstation: text,
      location: text,
      consumption_uom: text,
      production_uom: text,
    }).strict(),
    description: z.string(),
    produced_description: z.string().max(250).nullable().optional(),
    active: z.boolean(),
    lot_required: z.boolean(),
    updated_at: timestamp,
    expected_quantity: quantity.nullable().optional(),
    remaining_quantity: z.string().regex(/^-?\d+(?:\.\d+)?$/, 'Use uma quantidade decimal com ponto.').nullable().optional(),
    planned_output: quantity.nullable().optional(),
    qty_per_unit_of_measure: quantity.refine(value => /[1-9]/.test(value), 'O fator ERP deve ser positivo.').nullable().optional(),
  }).strict()),
  lots: z.array(z.object({
    id: uuid,
    erp_company: text,
    material_item: text,
    location: text,
    lot: text,
    quantity_available: quantity,
    updated_at: timestamp,
    container_reference: z.string().nullable(),
    container_quantity: quantity.nullable(),
  }).strict()),
}).strict()

export type ProductionCatalog = z.infer<typeof productionCatalogSchema>

export function catalogExample(userId: number): ProductionCatalog {
  const workstationId = crypto.randomUUID()
  const updatedAt = new Date().toISOString()
  return {
    workstations: [{ id: workstationId, code: 'POSTO-01', name: 'Posto exemplo', active: true }],
    access: [{ workstation_id: workstationId, user_id: userId }],
    jobs: [{
      id: crypto.randomUUID(),
      workstation_id: workstationId,
      context: {
        erp_company: 'EMPRESA', production_order: 'OP-EXEMPLO', order_line: 1, component_line: 1,
        produced_item: 'PRODUTO', material_item: 'MATERIAL', operation: '10', workstation: 'POSTO-01',
        location: 'ARMAZEM', consumption_uom: 'kg', production_uom: 'un',
      },
      description: 'Trabalho de exemplo — substituir antes de importar',
      active: true, lot_required: true, updated_at: updatedAt,
      expected_quantity: null, remaining_quantity: null, planned_output: null, qty_per_unit_of_measure: null,
    }],
    lots: [{
      id: crypto.randomUUID(), erp_company: 'EMPRESA', material_item: 'MATERIAL', location: 'ARMAZEM',
      lot: 'LOTE-EXEMPLO', quantity_available: '100.00', updated_at: updatedAt,
      container_reference: null, container_quantity: null,
    }],
  }
}
